import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, debounceTime, filter, from, Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre, CentreOption} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {FullChild} from "../../../../interfaces/FullChild";
import {ChildService} from "../../../../components/child/child.service";
import {MatSelectChange} from "@angular/material/select";
import {
  AbstractControl,
  FormControl,
  FormGroup, ValidationErrors, ValidatorFn,
  Validators,
  ɵFormGroupRawValue,
  ɵGetProperty,
  ɵTypedOrUntyped
} from "@angular/forms";
import {EducationService} from "../../education.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialogRef} from "@angular/material/dialog";
import {TitleCasePipe} from "@angular/common";
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";

@Component({
    selector: 'app-add-idividual-education',
    templateUrl: './add-idividual-education.component.html',
    styleUrls: ['./add-idividual-education.component.scss']
})
export class AddIdividualEducationComponent implements OnInit, OnDestroy {
    private _destroyed$ = new Subject<void>();
    mFilteredCentreOptions = new BehaviorSubject<Centre[]>([]); // Initialize with an empty array

    mAllCentreOptions: Centre[] = []
    centres$: Observable<Centre[]>
    docpath = 'educationTest/'
    dbType: any = 'firestore'
    formSaved = false
    childLog: any
    userData = JSON.parse(localStorage.getItem('userData')!)
    storagePath = 'EducationDocs'
    children$?: Observable<FullChild[]>
    selectedCentreCode!: string
    selectedCentreName!: string
    startTimeValue: any
    endTimeValue: any
  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;
    allCenters$!: Observable<CentreOption[]>;
    centreSelect: FormControl = new FormControl('', Validators.required)
    childSelect: FormControl = new FormControl('', Validators.required)
    childGender = ''
    form!: FormGroup
    isLoading :boolean = false
    private languagePercentage = 0;
    private languageGrade = '';
    private mathsPercentage = 0;
    private mathsGrade = '';
    private evsgkPercentage = 0;
    private evsgkGrade = '';
    maxDate = new Date()
    childData: FullChild[] = []
    showVolunteerName = false
    mVolunteers$: Observable<any>
    centreQuery: string = '';



  searchControl = new FormControl('');
  filteredChildData: any[] = [];

    constructor(readonly centreService: CentreService,
                readonly eduationService: EducationService,
                readonly matSnackBar: MatSnackBar,
                readonly childService: ChildService,
                private titlecasePipe: TitleCasePipe,
                private readonly mLogService: LogService,
                private readonly mDatabase: AngularFireDatabase,
                readonly mDialogRef: MatDialogRef<AddIdividualEducationComponent>) {
        // this.centres$ = centreService.getAllCentres()
        // this.centres$.subscribe(res => {
        //     this.mAllCentreOptions = res;
        //      this.mFilteredCentreOptions.next(res)
        // })
      this.centres$ = this.centreService.getAllCentres()
        this.mVolunteers$ = this.mDatabase.list('types/Volunteers').valueChanges()
    }


  onDropdownOpen() {
    // Focus search input when dropdown opens
    setTimeout(() => {
      const input = document.querySelector('.mat-select-search input') as HTMLInputElement;
      if (input) input.focus();
    });
  }

  // filterChildList(searchText: string) {
  //   if (!searchText) {
  //     this.filteredChildData = this.childData;
  //     return;
  //   }
  //
  //   const lower = searchText.toLowerCase();
  //
  //   this.filteredChildData = this.childData.filter(child =>
  //     `${child.firstName} ${child.lastName}`.toLowerCase().includes(lower) ||
  //     String(child.age).includes(lower)
  //   );
  // }

  filterChildList(searchValue: string | null) {
    if (!searchValue) {
      this.filteredChildData = this.childData;
      return;
    }

    const term = searchValue.toLowerCase();
    this.filteredChildData = this.childData.filter(c =>
      (`${c.firstName} ${c.lastName}`.toLowerCase().includes(term)) ||
      (c.age?.toString().includes(term))
    );
  }



  ngOnInit(): void {

    this.filteredChildData = this.childData;
    console.log("Filtered Child Data:", this.filteredChildData)

    // Apply filtering as user types
    this.searchControl.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(text=> {
      this.filterChildList(text);
    });

        this.initForm()
      const controlsToWatch = [
        'languageOral', 'languageWritten',
        'mathsOral', 'mathsWritten',
        'evsgkOral', 'evsgkWritten'
      ];
      controlsToWatch.forEach(controlName => {
        this.form.get(controlName)?.valueChanges.pipe(takeUntil(this._destroyed$)).subscribe(() => {
          this.calculateAndSetAverageAndRemark();
        });
      });
    }
  // calculateAndSetAverageAndRemark(): void {
  //   const lang = this.getLanguagePerc(
  //     this.form.get('languageOral')?.value,
  //     this.form.get('languageWritten')?.value
  //   );
  //
  //   const maths = this.getMathsPercentage(
  //     this.form.get('mathsOral')?.value,
  //     this.form.get('mathsWritten')?.value
  //   );
  //
  //   const evs = this.getEvsGKPercentage(
  //     this.form.get('evsgkOral')?.value,
  //     this.form.get('evsgkWritten')?.value
  //   );
  //
  //   const average = (lang + maths + evs) / 3;
  //   const roundedAvg = isNaN(average) ? 0 : Math.round(average);
  //
  //   this.form.get('averagePercentage')?.setValue(roundedAvg); // Optional, if you have this field
  //
  //   let remark = '';
  //   if (roundedAvg <= 20) {
  //     remark = 'Can do better';
  //   } else if (roundedAvg <= 40) {
  //     remark = 'Fair';
  //   } else if (roundedAvg <= 60) {
  //     remark = 'Good';
  //   } else if (roundedAvg <= 80) {
  //     remark = 'Very Good';
  //   } else {
  //     remark = 'Well Done';
  //   }
  //
  //   this.form.get('remark')?.setValue(remark);
  // }
  calculateAndSetAverageAndRemark(): void {
    const typeOfSession = this.form.get('sessionType')?.value;
    const subject = this.form.get('subject')?.value;
    const isIntermediate = typeOfSession === 'Intermediate Assessment';

    let finalScore = 0;

    if (isIntermediate) {
      // Calculate based on the selected subject only
      if (subject === 'Language') {
        finalScore = this.getLanguagePerc(
          this.form.get('languageOral')?.value,
          this.form.get('languageWritten')?.value
        );
      } else if (subject === 'Math') {
        finalScore = this.getMathsPercentage(
          this.form.get('mathsOral')?.value,
          this.form.get('mathsWritten')?.value
        );
      } else if (subject === 'EVS/GK') {
        finalScore = this.getEvsGKPercentage(
          this.form.get('evsgkOral')?.value,
          this.form.get('evsgkWritten')?.value
        );
      }
    } else {
      // Default case: use average of all 3 subjects
      const lang = this.getLanguagePerc(
        this.form.get('languageOral')?.value,
        this.form.get('languageWritten')?.value
      );
      const maths = this.getMathsPercentage(
        this.form.get('mathsOral')?.value,
        this.form.get('mathsWritten')?.value
      );
      const evs = this.getEvsGKPercentage(
        this.form.get('evsgkOral')?.value,
        this.form.get('evsgkWritten')?.value
      );
      finalScore = (lang + maths + evs) / 3;
    }

    const roundedScore = isNaN(finalScore) ? 0 : Math.round(finalScore);
    this.form.get('averagePercentage')?.setValue(roundedScore);

    let remark = '';
    if (roundedScore <= 20) {
      remark = 'Can do better';
    } else if (roundedScore <= 40) {
      remark = 'Fair';
    } else if (roundedScore <= 60) {
      remark = 'Good';
    } else if (roundedScore <= 80) {
      remark = 'Very Good';
    } else {
      remark = 'Well Done';
    }

    this.form.get('remark')?.setValue(remark);
  }

  private initForm() {
        this.form = new FormGroup({
            centreName: new FormControl('', Validators.required),
            centreCode: new FormControl('', Validators.required),
            childName: new FormControl('', Validators.required),
            childCode: new FormControl('', Validators.required),
            age: new FormControl('', Validators.required),
            dob: new FormControl('', Validators.required),
            sessionType: new FormControl('', Validators.required),
            languageLevel: new FormControl('', baselineRequiredValidator),
            languageOral: new FormControl('0', baselineRequiredValidator),
            languageWritten: new FormControl('0', baselineRequiredValidator),
            languagePercentage: new FormControl(this.languagePercentage, baselineRequiredValidator),
            languageGrade: new FormControl(this.languageGrade, baselineRequiredValidator),
            mathsLevel: new FormControl('', baselineRequiredValidator),
            mathsOral: new FormControl('0', baselineRequiredValidator),
            mathsWritten: new FormControl('0', baselineRequiredValidator),
            mathsPercentage: new FormControl(this.mathsPercentage, baselineRequiredValidator),
            mathsGrade: new FormControl(this.mathsGrade, baselineRequiredValidator),
            evsgkLevel: new FormControl('', baselineRequiredValidator),
            evsgkWritten: new FormControl('0', baselineRequiredValidator),
            evsgkOral: new FormControl('0', baselineRequiredValidator),
            evsgkPercentage: new FormControl(this.evsgkPercentage, baselineRequiredValidator),
            evsgkGrade: new FormControl(this.evsgkGrade, baselineRequiredValidator),
            gender: new FormControl('', Validators.required),
            sessionDate: new FormControl('', Validators.required),
            topicsCovered: new FormControl('', Validators.required),
            present: new FormControl('', Validators.required),
            subject: new FormControl('', [Validators.required, SessionTypeRequiredValidator]),
            sessionDetails: new FormControl('', Validators.required),
            remark: new FormControl('', Validators.required),
            startTime: new FormControl('', Validators.required),
            endTime: new FormControl('', Validators.required),
            submittedBy: new FormControl({value: this.userData.userName, disabled: true}, Validators.required),
            conductedBy: new FormControl('', Validators.required),
            createdAt: new FormControl(new Date()),
            unitCode: new FormControl('', Validators.required),
            absentReason: new FormControl('', absentConditionallyRequiredValidator),
            followUpChild: new FormControl('', Validators.required),
            volunteerName: new FormControl('')}, { validators: maxCombinedScoreValidator() });
        // this.form.get('gender')?.disable()
    }

    // onCentreSelect($event: any) {
    //     this.childData = []
    //     this.selectedCentreCode = $event.value.centreCode
    //     this.selectedCentreName = $event.value.centreName
    //     this.children$ = this.childService.getAllotedChildListByCenterAboveThree(this.selectedCentreCode)
    //     this.children$.subscribe(res => {
    //         res.forEach(c => {
    //             this.childData.push(c)
    //
    //         })
    //         this.childService.getDischargedChildListByCenterAboveThreeWithinThreeDaysEducation(this.selectedCentreCode).then(res => {
    //             let c = res.docs.map(x => x.data() as FullChild)
    //             console.log('DISCHARGED CHILDREN IN SELECT', c.length)
    //             c.forEach(res => {
    //                 this.childData.push(res)
    //                 this.childData = this.childData.filter(x => x.age > 3)
    //             })
    //         })
    //     })
    //
    //
    //     this.CenterName?.setValue($event.value.centreName)
    //     this.CentreCode?.setValue(this.selectedCentreCode)
    // }

  // onCentreSelect($event: any) {
  //   console.log($event);
  //
  //   // Check if the selection is valid
  //   if ($event && $event.centreName && $event.centreCode) {
  //     this.form.patchValue({
  //       centreName: $event.centreName,
  //       centreCode: $event.centreCode
  //     });
  //
  //     // Clear any previous errors
  //     this.form.get('centreName')?.setErrors(null);
  //     this.form.get('centreCode')?.setErrors(null);
  //   } else {
  //     // If invalid selection, clear the values and set error
  //     this.form.patchValue({
  //       centreName: '',
  //       centreCode: ''
  //     });
  //
  //     this.form.get('centreName')?.setErrors({ invalidSelection: true });
  //     this.form.get('centreCode')?.setErrors({ invalidSelection: true });
  //   }
  // }

  onCentreSelect($event: any) {
    console.log("Centre Selected:", $event);

    this.childData = [];
    this.filteredChildData = [];

    // Validate centre selection
    if (!$event || !$event.centreCode || !$event.centreName) {
      this.form.patchValue({
        centreName: '',
        centreCode: ''
      });
      return;
    }

    this.selectedCentreCode = $event.centreCode;
    this.selectedCentreName = $event.centreName;

    this.form.patchValue({
      centreName: this.selectedCentreName,
      centreCode: this.selectedCentreCode
    });

    // Load allotted children
    this.children$ = this.childService.getAllotedChildListByCenterAboveThree(
      this.selectedCentreCode
    );

    this.children$.pipe(takeUntil(this._destroyed$)).subscribe(allotted => {
      allotted.forEach(x => this.childData.push(x));

      // Load discharged children
      this.childService
        .getDischargedChildListByCenterAboveThreeWithinThreeDaysEducation(
          this.selectedCentreCode
        )
        .then(res => {
          const discharged = res.docs.map(x => x.data() as FullChild);
          discharged.forEach(x => this.childData.push(x));

          // Filter by age > 3
          this.childData = this.childData.filter(x => x.age > 3);

          // 👉 IMPORTANT — UPDATE FILTERED LIST
          this.filteredChildData = [...this.childData];

          console.log("Filtered Child Data:", this.filteredChildData);
        });
    });
  }



  onChildSelect($event: MatSelectChange) {
        let selectedChild = $event.value as FullChild
        this.form.get('gender')?.setValue({value: selectedChild.gender, disabled: true})
        this.ChildGender?.setValue(selectedChild.gender)
        this.ChildName?.setValue(`${selectedChild.firstName} ${selectedChild.lastName}`)
        this.ChildCode?.setValue(selectedChild.childCode)
        this.ChildAge?.setValue(selectedChild.age)
        this.ChildDob?.setValue(selectedChild.dob)
        this.ChildUnit?.setValue(selectedChild.selectUnit)
        this.ChildUnit?.disable()
        if (selectedChild.admissionData.length >= 3) this.form.get('followUpChild')?.setValue('Yes')
        else this.form.get('followUpChild')?.setValue('No')
    }

    get startTime() {
        return this.form.get('startTime')
    }

    get ChildUnit() {
        return this.form.get('unitCode')
    }

    get endTime() {
        return this.form.get('endTime')
    }

    get unitCode() {
        return this.form.get('unitCode')
    }

    get ChildGender() {
        return this.form.get('gender')
    }

    get ChildName() {
        return this.form.get('childName')
    }

    get ChildAge() {
        return this.form.get('age')
    }

    get ChildDob() {
        return this.form.get('dob')
    }

    get ChildCode() {
        return this.form.get('childCode')
    }

    get CenterName() {
        return this.form.get('centreName')
    }

    get CentreCode() {
        return this.form.get('centreCode')
    }

    get Subject() {
        return this.form.get('subject')
    }

    get TopicsCovered() {
        return this.form.get('topicsCovered')
    }

    get TypeOfSession() {
        return this.form.get('sessionType')
    }


  async Submit() {
    if (!this.form.valid) {
      alert('Please enter all fields carefully!!!');
      console.log(this.findInvalidControls());
      return;
    }
    this.isLoading = true;
    try {
      if (this.TypeOfSession?.value !== 'Baseline Assessment' &&
        this.TypeOfSession?.value !== 'Discharge Assessment' &&
        this.TypeOfSession?.value !== 'Intermediate Assessment') {

        this.form.removeControl('languageLevel');
        this.form.removeControl('languageOral');
        this.form.removeControl('languageWritten');
        this.form.removeControl('languagePercentage');
        this.form.removeControl('languageGrade');

        this.form.removeControl('mathsLevel');
        this.form.removeControl('mathsOral');
        this.form.removeControl('mathsWritten');
        this.form.removeControl('mathsPercentage');
        this.form.removeControl('mathsGrade');

        this.form.removeControl('evsgkLevel');
        this.form.removeControl('evsgkWritten');
        this.form.removeControl('evsgkOral');
        this.form.removeControl('evsgkPercentage');
        this.form.removeControl('evsgkGrade');
      }

      if (this.TypeOfSession?.value === 'Discharge Assessment') {
        this.form.removeControl('languageLevel');
        this.form.removeControl('evsgkLevel');
        this.form.removeControl('mathsLevel');
      }

      console.table(this.form.value);

      // REAL FIX: Await the async call
      const response = await this.eduationService.addIndividualSession(this.form.getRawValue());

      let id = response.id;
      this.formSaved = false;

      this.matSnackBar.open('Saved Successfully! ')._dismissAfter(3000);
      this.docpath += id;

      let activity = {
        date: Date.now(),
        section: 'Group Education',
        action: 'Submit',
        description: `Individual Session for ${this.form.get('childCode')?.value}, ${this.form.get('centreName')?.value} added to Education by user`,
        currentIp: localStorage.getItem('currentip')!
      };

      this.mLogService.addLog(activity);

      this.mDialogRef.close();

    } catch (err) {
      console.error('Save error:', err);
      alert('Failed to save session!');
    } finally {
      this.isLoading = false;
    }
  }



  onAttendaceSelect($event: MatSelectChange) {
        let attendance = $event.value
        if (attendance == 'Absent') {
            this.startTime?.disable()
            this.endTime?.disable()
            this.endTime?.disable()
            this.Subject?.disable()
            this.TopicsCovered?.disable()
            this.form.get('sessionType')?.disable()
            this.form.get('remark')?.disable()
            this.form.get('sessionDetails')?.disable()
        } else {
            this.startTime?.enable()
            this.endTime?.enable()
            this.endTime?.enable()
            this.Subject?.enable()
            if (this.TypeOfSession?.value != 'Rapport Building') this.TopicsCovered?.enable()
            this.form.get('sessionType')?.enable()
            if (this.TypeOfSession?.value != 'Rapport Building') this.form.get('remark')?.enable()
            this.form.get('sessionDetails')?.enable()
        }

    }

    close() {
        this.mDialogRef.close()
    }

    onBlur(formControl: any) {
        if (formControl.value !== null) {
            formControl.setValue(this.titlecasePipe.transform(formControl.value.toString().trim().toUpperCase()))
        }
    }

    onSessionTypeSelect($event: any): void {
        const selectedSessionType = this.form.get('sessionType')?.value;
        const subjectControl = this.form.get('remark');
        const topicControl = this.form.get('topicsCovered');

        if (selectedSessionType === 'Rapport Building') {
            this.form.get('subject')?.disable();
            this.form.get('remark')?.disable();
            this.form.get('topicsCovered')?.disable();
        } else {
            subjectControl?.enable();
            topicControl?.enable();
            this.form.get('subject')?.enable()
        }
    }

    OnConductedByChange($event: MatSelectChange) {
        if ($event.value === 'By Teacher') {
            this.showVolunteerName = false;
            this.form.get('volunteerName')?.setValue('')
        } else if ($event.value === 'By Volunteer') {
            this.showVolunteerName = true;
        }
    }

    getLanguagePerc(value1: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "languageOral"> | undefined, value2: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "languageWritten"> | undefined) {
        if (value1 != null && value2 != null) {
          const divisor = this.form.get('sessionType')?.value === 'Intermediate Assessment' ? 10 : 20;
            this.languagePercentage = (((value1 / divisor + value2 / divisor)) * 100)
            this.form.get('languagePercentage')?.setValue(this.languagePercentage)
            this.setGrade('languageGrade', parseInt(String(this.languagePercentage)))
            return this.languagePercentage
        }
        return 0
    }

    getMathsPercentage(value1: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "mathsOral"> | undefined, value2: ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "mathsWritten"> | undefined) {
        if (value1 != null && value2 != null) {
          const divisor = this.form.get('sessionType')?.value === 'Intermediate Assessment' ? 10 : 20;
            this.mathsPercentage = (((value1 / divisor + value2 / divisor)) * 100)
            this.form.get('mathsPercentage')?.setValue(this.mathsPercentage)
            this.setGrade('mathsGrade', parseInt(String(this.mathsPercentage)))


            return this.mathsPercentage
        }
        return 0
    }

  getEvsGKPercentage(value1: number | undefined, value2: number | undefined): number {
    const divisor = this.form.get('sessionType')?.value === 'Intermediate Assessment' ? 10 : 20;
    if (value1 != null && value2 != null) {
      this.evsgkPercentage = ((value1 / divisor + value2 / divisor) * 100);
      this.form.get('evsgkPercentage')?.setValue(this.evsgkPercentage);
      this.setGrade('evsgkGrade', parseInt(String(this.evsgkPercentage)));
      return this.evsgkPercentage;
    }
    return 0;
  }

  public findInvalidControls() {
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

    private setGrade(subject: string, percentage: number) {
        let grade = ''
        if (percentage >= 81 && percentage <= 100) {
            grade = 'A'
        }
        if (percentage >= 61 && percentage <= 80) {
            grade = 'B'
        }
        if (percentage >= 41 && percentage <= 60) {
            grade = 'C'
        }
        if (percentage <= 40) {
            grade = 'D'
        }
        this.form.get(subject)?.setValue(grade)

    }

    // filterCentres() {
    //
    // }
    filterCentres() {
    //     const centreObservable = from(this.mFilteredCentreOptions.getValue()); // Get current value from BehaviorSubject
    //
    //     centreObservable.pipe(
    //
    //         // debounceTime(300), // Debounce to reduce unnecessary filtering
    //         filter((centres: Centre[]) => centres.some((centre: Centre) => centre.centreName.toLowerCase().includes(this.centreQuery.toLowerCase()))),
    //         distinctUntilChanged(), // Prevent re-emitting the same value
    //
    //     ).subscribe(filteredCentres => {
    //         this.mFilteredCentreOptions.next(filteredCentres); // Update BehaviorSubject with filtered data
    //     });
    }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
function absentConditionallyRequiredValidator(formControl: AbstractControl) {
    if (!formControl.parent) {
        return null;
    }

    if (formControl.parent.get('present')?.value == 'Absent') {
        return Validators.required(formControl);
    }
    return null;
}

function baselineRequiredValidator(formControl: AbstractControl) {
    if (!formControl.parent) {
        return null;
    }

    if (formControl.parent.get('sessionType')?.value == 'Baseline Assessment') {
        return Validators.required(formControl);
    }
    return null;

}

function SessionTypeRequiredValidator(formControl: AbstractControl) {
    if (!formControl.parent) {
        return null;
    }

    if (formControl.parent.get('sessionType')?.value == 'Rapport Assessment') {
        return Validators.required(formControl);
    }
    return null;
}

function maxCombinedScoreValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const errors: any = {};
    const typeOfSession = formGroup.get('sessionType')?.value;
    const maxScore = typeOfSession === 'Intermediate Assessment' ? 10 : 20;
    const languageOral = Number(formGroup.get('languageOral')?.value || 0);
    const languageWritten = Number(formGroup.get('languageWritten')?.value || 0);
    const mathsOral = Number(formGroup.get('mathsOral')?.value || 0);
    const mathsWritten = Number(formGroup.get('mathsWritten')?.value || 0);
    const evsgkOral = Number(formGroup.get('evsgkOral')?.value || 0);
    const evsgkWritten = Number(formGroup.get('evsgkWritten')?.value || 0);

    if ((languageOral + languageWritten) > maxScore) {
      errors.languageScoreExceeded = {
        total: languageOral + languageWritten,
        maxAllowed: maxScore,
      };
    }

    if ((mathsOral + mathsWritten) > maxScore) {
      errors.mathScoreExceeded = {
        total: mathsOral + mathsWritten,
        maxAllowed: maxScore,
      };
    }

    if ((evsgkOral + evsgkWritten) > maxScore) {
      errors.evsgkScoreExceeded = {
        total: evsgkOral + evsgkWritten,
        maxAllowed: maxScore,
      };
    }

    return Object.keys(errors).length ? errors : null;
  };
}



